export default __webpack_public_path__ + "static/media/a6.cd34888e.png";